import React from 'react'

const useDropdownPosition = () => {
  const refButton = React.useRef(null)
  const refDropdown = React.useRef(null)

  const updateDropdownPosition = () => {
    let position

    const { left, right } = refButton?.current?.getBoundingClientRect() ?? {}
    const { width } = refDropdown?.current?.getBoundingClientRect() ?? {}

    if (window.innerWidth - right < width / 2) {
      position = 'right'
    } else if (left < width / 2) {
      position = 'left'
    } else {
      position = 'center'
    }

    refDropdown.current?.setAttribute('data-position', position)
  }

  React.useEffect(() => {
    updateDropdownPosition()

    window.addEventListener('resize', updateDropdownPosition)

    return () => window.removeEventListener('resize', updateDropdownPosition)
  }, [])

  return { refButton, refDropdown }
}

export default useDropdownPosition
